import { atomWithKey as atom } from "./atomWithKey";
import { CountryType } from "../Types/Types/Country/CountryType";
import { CountryCodesType } from "../Types/Types/Country/CountryCodesType";

const initialCountryData: CountryType[] = [];
const initialCountryCodes: CountryCodesType[] = [];

export const countryAtom = atom<CountryType[]>({
    key: "countryAtom",
    default: initialCountryData,
});

export const countryCodesAtom = atom<CountryCodesType[]>({
    key: "countryCodesAtom",
    default: initialCountryCodes,
});
